import checkWelcomeCTAValid from './checkWelcomeCTAValid';
import checkWelcomeCTAStyleStatus from './checkWelcomeCTAStyleStatus';
import {
  updateNewOrderInfoToOrderVo,
  updateExistingOrderInfoToOrderVo,
  updateAddonOrderInfoToOrderVo,
} from './updateReduxInfoToOrderVo';
import checkServeTypeValid from './checkServeTypeValid';

const WelcomeCTAUtils = {
  checkWelcomeCTAValid,
  checkWelcomeCTAStyleStatus,
  updateNewOrderInfoToOrderVo,
  updateExistingOrderInfoToOrderVo,
  updateAddonOrderInfoToOrderVo,
  checkServeTypeValid,
};
export default WelcomeCTAUtils;
